<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 74.94 74.94">
  <path
    d="M11.3 28.25c-1.77,-1.77 -1.77,-4.64 0,-6.41 1.77,-1.77 4.64,-1.77 6.41,0l19.76 19.76 19.76 -19.76c1.77,-1.77 4.64,-1.77 6.41,0 1.77,1.77 1.77,4.64 0,6.41l-26.16 26.16 -26.16 -26.16z"/>
</svg>
